import Axios from "@app/api/axios";
import { CUSTOMERS } from "@utils/constant";

const customerService = (query) =>
  Axios.get(`${CUSTOMERS}?per_page=1000&${query}`).then((response) => response);

export default customerService;
